/**
 * Custom: lægger valgte tilvalg i kurven, når hovedproduktet er lagt i kurven
 * (se snippets/product-addons.liquid). Temaets egen "Læg i kurv" bruges uændret;
 * tilvalgene tilføjes lige bagefter, og kurven opdateres.
 */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';

  document.body.addEventListener('baseline:cart:afteradditem', async (e) => {
    const form = e.detail && e.detail.sourceId ? document.getElementById(e.detail.sourceId) : null;
    if (!form) return;

    const box = form.querySelector('[data-product-addons]');
    if (!box) return;

    const checked = [...box.querySelectorAll('[data-product-addon]:checked')];
    if (!checked.length) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    const items = checked.map((input) => ({ id: Number(input.value), quantity }));

    const error = box.querySelector('[data-product-addons-error]');
    if (error) error.textContent = '';

    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error((await res.json()).description);
      checked.forEach((input) => {
        input.checked = false;
      });
    } catch (err) {
      if (error) error.textContent = err.message || box.dataset.error;
    } finally {
      // Opdater kurv, kurvtæller osv.
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    }
  });
})();
